import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownloadIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackAwardModalSharing = ({
  certFileName,
  certObjectUrl,
  onClickShareThis,
  onDownloadCertificate,
  shareThisPath
}) => {
  const history = useHistory();
  const location = useLocation();
  const clickShareThis = useCallback(() => {
    onClickShareThis();
    // Replace history entry to prevent award modal from reopening on browser back
    history.replace(shareThisPath, {
      backFromAwardShare: location
    });
  }, [history, location, shareThisPath, onClickShareThis]);
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "500",
    marginInline: "0",
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": "share-this-button",
      marginInlineEnd: "200",
      onClick: clickShareThis,
      paddingInline: "200",
      responsive: false,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.trackAwardModal.shareThisCertificate"
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "award-download-button",
      disabled: !certObjectUrl,
      download: certFileName,
      href: certObjectUrl,
      onClick: onDownloadCertificate,
      paddingBlock: "200",
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.trackAwardModal.downloadCertificate"
      }),
      children: /*#__PURE__*/_jsx(DownloadIcon, {
        size: "500"
      })
    })]
  });
};
export default TrackAwardModalSharing;